import { useContext } from 'react';

import type { I18nContextValue } from '@/components/i18n/LocaleRuntime';
import { I18nContext } from '@/components/i18n/LocaleRuntime';
import { getIntlLocale, getLocaleDirection, SUPPORTED_LOCALES } from '@/features/i18n/logic';
import { getI18nPayload } from '@/features/i18n/payload';

let devLocaleRuntimeFallback: I18nContextValue | undefined;

const getDevLocaleRuntimeFallback = (): I18nContextValue => {
    if (!devLocaleRuntimeFallback) {
        const payload = getI18nPayload('en');
        devLocaleRuntimeFallback = {
            locale: payload.locale,
            dictionary: payload.dictionary,
            landingContent: payload.landingContent,
            direction: getLocaleDirection(payload.locale),
            intlLocale: getIntlLocale(payload.locale),
            localeOptions: SUPPORTED_LOCALES.map((value) => ({
                value,
                label: payload.dictionary.languages[value],
            })),
            setLocale: () => undefined,
        };
    }

    return devLocaleRuntimeFallback;
};

export const useLocaleRuntime = () => {
    const context = useContext(I18nContext);

    if (!context) {
        if (process.env.NODE_ENV !== 'production') {
            return getDevLocaleRuntimeFallback();
        }

        throw new Error('useLocaleRuntime must be used within LocaleRuntime.');
    }

    return context;
};
